const STORAGE_KEY = 'or_social_intent';
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

export function parseSocialIntent(value: string | null | undefined): string | null {
  return value && /^reference:[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value) ? value : null;
}

export function readSocialIntent(): string | null {
  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    const { value, savedAt } = JSON.parse(stored);
    if (typeof savedAt === 'number' && savedAt <= Date.now() && Date.now() - savedAt <= MAX_AGE_MS && parseSocialIntent(value)) {
      return value;
    }
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage may be unavailable or contain malformed data.
    try { window.sessionStorage.removeItem(STORAGE_KEY); } catch { /* unavailable */ }
  }
  return null;
}

export function saveSocialIntent(value: string | null): void {
  try {
    const intent = parseSocialIntent(value);
    if (intent) {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ value: intent, savedAt: Date.now() }));
    } else {
      window.sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // The current page can continue without session storage.
  }
}
